import type { Station } from "@station/domain/models/station.model.ts";
import type { StationRepository } from "@station/domain/repositories/station.repository.ts";
import { stationsTypes } from "@station/station-types.di.ts";
import { inject, injectable } from "inversify";
import type { Nullable } from "ts-toolbelt/out/Union/Nullable";

@injectable()
export class StationGetByUseCase {
    constructor(
        @inject(stationsTypes.repositories.StationRepository)
        private readonly stationRepository: StationRepository,
    ) {}

    async execute(stationId: number): Promise<Nullable<Station>> {
        const stationResult = this.stationRepository.getStationBy(stationId);

        return stationResult.match(
            (station) => station,
            () => null,
        );
    }
}
